export default {
  order: 2,
  name: "Salary Advance",
  icon: "mdi-cash-fast",
  to: "/advance/list",
  hasSubs: 0,
};
